
// Currency
export const CURRENT_CURRENCY_SYMBOL = "₹";

export const CDN_SERVER_URL = "//cdn.dotpe.in/cfe/";

export const GA_ID = "UA-156204764-1";

// General UPI intent
export const ANDROID_UPI_INTENT_LINK = "upi://{deeplink}";
// Google Pay intent link
export const ANDROID_GOOGLE_PAY_INTENT_LINK = "intent://{deeplink}#Intent;scheme=upi;package=com.google.android.apps.nbu.paisa.user;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.google.android.apps.nbu.paisa.user;end";
export const IOS_GOOGLE_PAY_INTENT_LINK = "tez://upi/{deeplink}";
export const IOS_GOOGLE_PAY_APP_LINK = "https://apps.apple.com/in/app/google-pay-for-india-tez/id1193357041";
// PhonePe intent link
export const ANDROID_PHONEPE_INTENT_LINK = "intent://{deeplink}#Intent;scheme=upi;package=com.phonepe.app;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.phonepe.app&hl=en_IN;end";
export const IOS_PHONEPE_INTENT_LINK = "phonepe://{deeplink}";
export const IOS_PHONEPE_APP_LINK = "https://apps.apple.com/in/app/phonepe-indias-payments-app/id1170055821";
// PayTM intent link
export const ANDROID_PAYTM_INTENT_LINK = "intent://{deeplink}#Intent;scheme=upi;package=net.one97.paytm;S.browser_fallback_url=https://play.google.com/store/apps/details?id=net.one97.paytm;end";
export const IOS_PAYTM_INTENT_LINK = "paytmmp://upi/{deeplink}";
// PayZapp intent link
export const ANDROID_PAYZAPP_INTENT_LINK = "intent://{deeplink}#Intent;scheme=upi;package=com.enstage.wibmo.hdfc;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.enstage.wibmo.hdfc&hl=en_IN;end";

// Whatsappp intent link
export const ANDROID_WHATSAPP_INTENT_LINK = "intent://{deeplink}#Intent;scheme=upi;package=com.whatsapp;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.whatsapp;end";
export const IOS_WHATSAPP_INTENT_LINK = "whatsapp://{deepLink}";